function getDataDependency(component, methodName) {
  if (typeof component[methodName] === 'function') {
    return component[methodName];
  }
  if (component.WrappedComponent) {
    return getDataDependency(component.WrappedComponent, methodName);
  }
  return null;
}
export default getDataDependency;